import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Modal } from '../../../../components';
import { deleteOrganization } from '../../../../store/orgs/orgs.actions';
import { RootState } from '../../../../store/store';

type DeleteOrgModalProps = {
  onClose: () => void;
  open: boolean;
};

export const DeleteOrgModal: React.FC<DeleteOrgModalProps> = ({
  onClose,
  open,
}: DeleteOrgModalProps): JSX.Element => {
  const { currentOrg } = useSelector((state: RootState) => state.orgs);
  const [deleted, setDeleted] = useState(false);
  const dispatch = useDispatch();

  const handleDelete = () => {
    setDeleted(true);
  };

  const handleClose = () => {
    dispatch(deleteOrganization(currentOrg?.orgId || ''));
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={deleted ? handleClose : onClose}
      title={deleted ? 'Delete organization' : 'Are you sure?'}
    >
      {deleted ? (
        <div>
          <div>
            <span className="delete-user-modal__users">{currentOrg?.name}</span>{' '}
            has been <span className="delete-user-modal__users">removed</span>{' '}
            from organizations
            <Button
              onClick={onClose}
              variant="common"
              className="delete-user-modal__btn"
            >
              Undo
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <div>
            Are you sure you would like to delete{' '}
            <span className="delete-user-modal__users">{currentOrg?.name}</span>
            ?
          </div>
          <Button
            className="delete-user-modal__btn"
            onClick={onClose}
            variant="common"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            className="delete-user-modal__btn"
            variant="text"
          >
            Delete
          </Button>
        </div>
      )}
    </Modal>
  );
};
